import { Box, Flex } from '@chakra-ui/react'
import { useState } from 'react'
import '@/assets/css/poppins.css'
import { EmailAndPassword, SendEmailCode } from '@/components/steps/login-steps'

const LoginDashboard = () => {
	const [iu, setIu] = useState<string>('email')
	const [email, setEmail] = useState<string>('')

	return (
		<Box
			w='full'
			h='100vh'
			bg='gray.50'
			display='flex'
			justifyContent='center'
			alignItems='center'
		>
			<Flex
				w={{ base: '95%', sm: '90%', md: '70%', lg: '45%', xl: '40%' }}
				border='0.1px solid'
				borderColor='gray.400'
				borderRadius='xl'
				boxShadow='lg'
				bg='white'
				p='8'
				flexDirection='column'
				alignItems='center'
			>
				{iu === 'email' && (
					<EmailAndPassword state={setIu} emailState={setEmail} />
				)}
				{iu === 'code' && <SendEmailCode email={email} state={setIu} />}
			</Flex>
		</Box>
	)
}

export default LoginDashboard
